import {VideoOverlayItemDefaultBox} from "./video-overlay-item.default.box";

export const VideoOverlayItemBox = VideoOverlayItemDefaultBox;
